module.exports = __webpack_public_path__ + "static/media/sona-buvelle.2727d20e.png";